const ZIP_CODE_REGEXP = /^[0-9]{5}$/;

export const isZipCode = (str) => ZIP_CODE_REGEXP.test(String(str) || '');
